import { Field } from '@progress/kendo-react-form';
import * as React from 'react';
import { StackLayout, TextArea } from '../../../ui';
import FormDialog from '../../../ui/components/application/form-dialog';
import { registerForLocalization, provideLocalizationService } from '@progress/kendo-react-intl';
import { COMMENT_LENGTH_LIMITS } from '../../../resources/commentLengthLimits';

class CompetencyRequestReturnForm extends React.PureComponent {
  render() {
    const localizationService = provideLocalizationService(this);
    return (
      <FormDialog
        title={localizationService.toLanguageString('competencyRequest.returnDialogTitle')}
        onSubmit={this.props.onSubmit}
        onCancel={this.props.onCancel}
        validator={this.validateReturnCompetencyDialog}
        confirmButtonText={localizationService.toLanguageString('buttons.return')}
        closeButtonText={localizationService.toLanguageString('buttons.close')}
        width={'640px'}
        render={() => (
          <StackLayout>
            <Field
              name='comment'
              label={localizationService.toLanguageString('competencyRequest.comment')}
              component={TextArea}
              rows={5}
              autoSize={true}
              characterLimit={COMMENT_LENGTH_LIMITS.RETURN_REASON}
            />
          </StackLayout>
        )}
      />
    );
  };

  validateReturnCompetencyDialog(values, localizationService, validationResult, modified) {
    const maxCommentLength = COMMENT_LENGTH_LIMITS.RETURN_REASON;
    const errors = {};
    if (values.comment && values.comment.length > maxCommentLength) {
      errors.comment = `${localizationService.toLanguageString('validation.exceedsMaximumLength')} (${maxCommentLength})`;
    }
    if (!modified.comment) {
      if (validationResult?.errors?.comment) {
        errors.comment = validationResult?.errors?.comment;
      }
    }
    return errors;
  }
}

registerForLocalization(CompetencyRequestReturnForm);

export default CompetencyRequestReturnForm;